
export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'New Vehicle Brokering',
      description: 'Access to every make and model from 50+ dealerships across Ontario. Get the exact vehicle you want at the best possible price.',
      features: ['All Makes & Models', 'Factory Incentives', 'Executive Pricing']
    },
    {
      icon: 'ri-exchange-line',
      title: 'Trade-In Optimization',
      description: 'Get maximum value for your current vehicle. We negotiate trade-in values that dealerships won\'t offer directly to consumers.',
      features: ['Market Analysis', 'Multiple Offers', 'Best Value Guaranteed']
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Financing Solutions',
      description: 'Access to competitive financing rates through multiple lenders. We find the best terms for your situation.',
      features: ['Rate Comparison', 'Pre-Approval', 'Flexible Terms']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Lease Negotiations',
      description: 'Expert lease structuring and negotiation. Get lower monthly payments and better terms than going direct.',
      features: ['Lower Payments', 'Flexible Mileage', 'End-of-Lease Options']
    },
    {
      icon: 'ri-time-line',
      title: 'Time-Saving Service',
      description: 'No dealership visits required. We handle everything from sourcing to delivery, saving you 40+ hours on average.',
      features: ['Zero Dealership Visits', 'Home Delivery', 'Complete Paperwork']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Ongoing Support',
      description: 'Lifetime support for all your automotive needs. Questions about your vehicle? We\'re always here to help.',
      features: ['24/7 Availability', 'Service Recommendations', 'Future Purchase Planning']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Services Grid */}
        <header className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Complete <strong>Auto Brokering Services</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Everything you need to buy your next vehicle with confidence and savings
          </p>
        </header>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all group"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-cyan-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-20 text-center">
          <div className="relative bg-gradient-to-r from-white to-blue-50 rounded-3xl p-16 shadow-xl overflow-hidden">
            {/* Background Image */}
            <div className="absolute inset-0">
              <img
                src="https://static.readdy.ai/image/5fb4188dc1db6e50d6c3e79cbe3ab0af/e60ec4b6cd4443a77aea29d90e3ec017.jpeg"
                alt="Kevin Schleifer - AI-Powered Auto Broker Woodbridge"
                title="Auto Broker Woodbridge Ontario"
                className="w-full h-full object-cover object-top opacity-20"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-white/90 to-blue-50/90"></div>
            </div>

            {/* Content */}
            <div className="relative z-10">
              <h4 className="text-4xl leading-tight mb-8">
                <span className="text-gray-700">The smartest car buyers in</span>
                <br />
                <span className="italic text-purple-600 font-semibold"><strong>Woodbridge</strong></span>
                <br />
                <span className="text-gray-900 font-bold">use <strong>AI-powered brokers</strong></span>
              </h4>
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-black text-white px-12 py-5 rounded-full text-lg font-semibold hover:scale-105 hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap inline-flex items-center space-x-3"
              >
                <span>START YOUR FREE AI CONSULTATION</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <div className="mt-6 text-gray-600 text-sm">
                ⚡ 2-minute setup • 💬 No obligation • 🔒 100% confidential
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
